

exports.__esModule = true;
exports.$ThirdPartyWalletFlowRoute = undefined;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ThirdPartyWalletFlowRoute = exports.$ThirdPartyWalletFlowRoute = _squid.$Route.extend('$ThirdPartyWalletFlowRoute', {
    path: 'thirdPartyWalletFlow',
    directive: _directive2['default'],

    auth: false,

    trackingData: {
        fptiState: 'third_party_wallet_flow',
        trackStateExit: true
    }
});

angular.value("$ThirdPartyWalletFlowRoute", $ThirdPartyWalletFlowRoute);
_squid.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-third-party-wallet/route.js
// module id = ./pages/xo-third-party-wallet/route.js
// module chunks = 0